import { signal } from 'services/SignalsService'

export default class InitManager {
  constructor() {
    signal.on('STATE:IN:BET', () => {
      signal.on('SPLASH-OUT', this.checkInitState.bind(this))
    })
    signal.on('STATE:IN:SPIN', () => {
      signal.on('SPLASH-OUT', this.checkInitState.bind(this))
    })
    signal.on('STATE:IN:FB-ADD', () => {
      signal.on('SPLASH-OUT', () => {
        signal.dispatch('FREE-BETS')
      })
    })
    signal.on('STATE:IN:FREE-BET', () => {
      signal.on('SPLASH-OUT', () => {
        signal.dispatch('FREE-BETS')
      })
    })
  }

  checkInitState() {
    const freespinModel = game.models.FreespinModel.get()
    signal.dispatch(freespinModel.all
      ? 'FREESPINS'
      : 'REGULAR')
  }
}
